import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  $,
  r,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/highlight/highlight.style.ts
var highlight_style_default = r` ${component_styles_default} :host { font-family: var(--sl-font-sans); } .highlight { background: var(--highlight-background); border: 1px solid var(--card-border-color); box-shadow: var(--card-box-shadow); border-radius: var(--card-border-radius); color: var(--sl-color-neutral-0); min-height: 85px; display: flex; flex-direction: row; justify-content: space-between; transition: all 0.4s ease; } .highlight--hovered { background: var(--sl-color-neutral-0); color: var(--sl-color-primary-600); transform: translateY(10px); cursor: pointer; transition: all 0.4s ease; } .highlight .highlight__content { align-items: center; display: flex; margin: 10px 30px; } .highlight .highlight__content fadv-icon { margin-right: 20px; padding: 10px; border: 1px solid var(--sl-color-neutral-0); box-shadow: none; color: var(--sl-color-neutral-0); } .highlight .highlight__value { display: flex; align-items: center; margin: 10px 30px; } @keyframes move { from { top: 0; left: 0; } to { top: 100px; left: 100px; } } `;

// src/components/highlight/highlight.ts
var FadvHighlight = class extends s {
  constructor() {
    super(...arguments);
    this.isHovered = false;
  }
  handleMouseEnter() {
    this.isHovered = true;
  }
  handleMouseLeave() {
    this.isHovered = false;
  }
  render() {
    return $`<div class=${o({
      highlight: true,
      "highlight--hovered": this.isHovered
    })} role="mark" @mouseenter=${this.handleMouseEnter} @mouseleave=${this.handleMouseLeave} ><div class="highlight__content"><fadv-icon size="large" library=${l(this.library)} name=${l(this.name)} label=${l(this.label)} src=${l(this.src)} background="${this.isHovered ? "primary" : null}" ></fadv-icon><span class="highlight__title"><fadv-typography type="label-large" weight="500"><slot></slot></fadv-typography></span></div><span class="highlight__value"><fadv-typography type="heading-medium" weight="500">${this.value}</fadv-typography></span></div>`;
  }
};
FadvHighlight.styles = highlight_style_default;
__decorateClass([
  e()
], FadvHighlight.prototype, "library", 2);
__decorateClass([
  e()
], FadvHighlight.prototype, "name", 2);
__decorateClass([
  e()
], FadvHighlight.prototype, "src", 2);
__decorateClass([
  e()
], FadvHighlight.prototype, "label", 2);
__decorateClass([
  e({ reflect: true })
], FadvHighlight.prototype, "value", 2);
__decorateClass([
  t()
], FadvHighlight.prototype, "isHovered", 2);
FadvHighlight = __decorateClass([
  n("fadv-highlight")
], FadvHighlight);

export {
  FadvHighlight
};
